import { Divider, Drawer, List, styled } from "@mui/material";
import PathConstants from "../../../constants/PathConstants";
import SideMenuListItem from "../../atoms/SideMenuListItem";
import LayoutConstants from "../../../constants/LayoutConstants";
import HaccpTextConstants from "src/haccp/constants/TextConstants";
import SideMenuHeader from "./SideMenuHeader";

/** スタイルが適用されたDrawerコンポーネント */
const StyledDrawer = styled(Drawer)(({
    width: LayoutConstants.SideMenuWidth,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
        width: LayoutConstants.SideMenuWidth
    },
}));

/** SideMenuコンポーネントで使用するListコンポーネント */
const SideMenuList = () => {
    return (
        <List>
            <SideMenuListItem path={PathConstants.TempMeasurementRegistration}>
                {HaccpTextConstants.TempMeasurementRegistration.Title}
            </SideMenuListItem>
            <SideMenuListItem path={PathConstants.CookingTempMeasurementRegistration}>
                {HaccpTextConstants.CookingTempMeasurementRegistration.Title}
            </SideMenuListItem>
            {/* <SideMenuListItem path={PathConstants.HeatingAndCoolingTempMeasurementRegistration}>
                {HaccpTextConstants.HeatingAndCoolingTempMeasurementRegistration.Title}
            </SideMenuListItem> */}
            <SideMenuListItem path={PathConstants.TempMeasurementRecord}>
                {HaccpTextConstants.TempMeasurementRecord.Title}
            </SideMenuListItem>
            <SideMenuListItem path={PathConstants.ReceivingTempMeasurementRecord}>
                {HaccpTextConstants.ReceivingTempMeasurementRecord.Title}
            </SideMenuListItem>
            <SideMenuListItem path={PathConstants.CookingTempMeasurementRecord}>
                {HaccpTextConstants.CookingTempMeasurementRecord.Title}
            </SideMenuListItem>
            {/* <SideMenuListItem path={PathConstants.HeatingAndCoolingTempMeasurementRecord}>
                {HaccpTextConstants.HeatingAndCoolingTempMeasurementRecord.Title}
            </SideMenuListItem> */}
            <SideMenuListItem path={PathConstants.CabinetTempMeasurementRecord}>
                {HaccpTextConstants.CabinetTempMeasurementRecord.Title}
            </SideMenuListItem>
        </List>
    );
};

/** サイドメニュー コンポーネント */
export const SideMenu = ({ open }) => {
    return (
        <StyledDrawer anchor="left" variant="persistent" open={open}>
            <SideMenuHeader/>
            <Divider />
            <SideMenuList />
        </StyledDrawer>
    );
};
